const scriptLoaded = {}
const cached = {}

let defineProxy = null
window.$define = function (deps, callback) {
  defineProxy = callback()
}

export default (src, options = {}) => {
  if (!src) return

  const { useCache = true } = options
  if (useCache) {
    if (cached[src]) {
      return cached[src]
    }
  }

  // 脚本语法错误捕获
  let $reject
  const errHandler = e => {
    if (document.currentScript?.src.includes(src)) {
      $reject(new Error('脚本存在语法错误，请检查并修复'))
    }
  }

  const promise = new Promise((resolve, reject) => {
    $reject = reject
    const script = document.createElement('script')
    script.src = src
    script.onload = () => {
      resolve(defineProxy)
      scriptLoaded[src] = true
    }
    script.onerror = () => {
      reject(new Error('资源加载失败'))
    }
    window.addEventListener('error', errHandler)
    document.body.appendChild(script)
  })
  if (useCache) {
    cached[src] = promise
  }
  promise.finally(() => {
    window.removeEventListener('error', errHandler)
  })
  return promise
}